import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { OverlayTrigger, Popover} from 'react-bootstrap'

class MessageBox extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
  
        };
      } 
  
      static defaultProps = {
      }
  
      componentDidMount(){
      }
  
      onItemSelectionChanged = (rowId) => {
  
      }

      popover = (
        <Popover id="popover-basic">
          <Popover.Title as="h3">Message</Popover.Title>
          <Popover.Content>
            We will be releasing the approved version of Billing App to production on <strong>Monday 26 April at 09:00</strong>. We do not expect any downtime, but you will need to log out and log back in again during this time. Please monitor the system for any anomalies and report them as soon as possible.
            <br/>
            Stanley
            <br/>
            <br/>
            <button type="button" className="btn btn-success btn-sm">Mark as read</button>
          </Popover.Content>
        </Popover>
      );

      render(){
  
          return (
            // <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/5.3.45/css/materialdesignicons.css" integrity="sha256-NAxhqDvtY0l4xn+YVa6WjAcmd94NNfttjNsDmNatFVc=" crossorigin="anonymous" />


                    <div>
                        <div className="box shadow-sm rounded bg-white mb-3">
                            <div className="box-title border-bottom p-3">
                                <h6 className="m-0">Recent</h6>
                            </div>
                            <div className="box-body p-0">
                                <OverlayTrigger trigger="click" placement="right" overlay={this.popover}>
                                    <div className="p-3 d-flex align-items-center border-bottom osahan-post-header fuseHover">
                                    <div className="dropdown-list-image mr-3">
                                        <img className="rounded-circle" src="https://bootdey.com/img/Content/avatar/avatar7.png" alt="" />
                                    </div>
                                        <div className="font-weight-bold mr-3">
                                            <div className="text-truncate">BILLING APP RELEASE</div>
                                            <div className="small">New version scheduled for release</div>
                                        </div>
                                        <span className="ml-auto mb-auto">
                                            <i className="text-info fa fa-envelope"></i>
                                            {/* <div className="btn-group">
                                                <button type="button" className="btn btn-light btn-sm rounded" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-right">
                                                    <button className="dropdown-item" type="button"><i className="mdi mdi-delete"></i> Delete</button>
                                                    <button className="dropdown-item" type="button"><i className="mdi mdi-close"></i> Turn Off</button>
                                                </div>
                                            </div> */}
                                            <br />
                                            <div className="text-right text-muted pt-1">1h</div>
                                        </span>
                                    </div>
                                </OverlayTrigger>
                                <OverlayTrigger trigger="click" placement="right" overlay={this.popover}>
                                <div className="p-3 d-flex align-items-center border-bottom osahan-post-header fuseHover">
                                    <div className="dropdown-list-image mr-3 d-flex align-items-center bg-secondary justify-content-center rounded-circle text-white">B.APP</div>
                                    <div className="font-weight-bold mr-3">
                                        <div className="text-truncate">HIGH-VALUE APPROVAL</div>
                                        <div className="small">You have a new high-value approval request to action and prioritize.</div>
                                    </div>
                                    <span className="ml-auto mb-auto">
                                        <i className="text-success fa fa-check-circle"></i>
                                        {/* <div className="btn-group">
                                            <button type="button" className="btn btn-light btn-sm rounded" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="mdi mdi-dots-vertical"></i>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-delete"></i> Delete</button>
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-close"></i> Turn Off</button>
                                            </div>
                                        </div> */}
                                        <br />
                                        <div className="text-right text-muted pt-1">2h</div>
                                    </span>
                                </div>
                                </OverlayTrigger>
                                <OverlayTrigger trigger="click" placement="right" overlay={this.popover}>
                                    <div className="p-3 d-flex align-items-center osahan-post-header fuseHover">
                                        <div className="dropdown-list-image mr-3">
                                            <img className="rounded-circle" src="https://bootdey.com/img/Content/avatar/avatar1.png" alt="" />
                                        </div>
                                        <div className="font-weight-bold mr-3">
                                                <div className="text-truncate">FINALIZE MARCH POSTINGS</div>
                                                <div className="small">We want to close the March financial month on Acumatica. Please make sure that all failed postings are resolved.<br/>Warren</div>
                                            </div>
                                        <span className="ml-auto mb-auto">
                                        <i className="text-info fa fa-envelope"></i>
                                            {/* <div className="btn-group">
                                                <button type="button" className="btn btn-light btn-sm rounded" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-right">
                                                    <button className="dropdown-item" type="button"><i className="mdi mdi-delete"></i> Delete</button>
                                                    <button className="dropdown-item" type="button"><i className="mdi mdi-close"></i> Turn Off</button>
                                                </div>
                                            </div> */}
                                            <br />
                                            <div className="text-right text-muted pt-1">1d</div>
                                        </span>
                                    </div>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="box shadow-sm rounded bg-white mb-3">
                            <div className="box-title border-bottom p-3">
                                <h6 className="m-0">Earlier</h6>
                            </div>
                            <div className="box-body p-0">
                                <OverlayTrigger trigger="click" placement="right" overlay={this.popover}>
                                <div className="p-3 d-flex align-items-center border-bottom osahan-post-header fuseHover">
                                    <div className="dropdown-list-image mr-3 d-flex align-items-center bg-info justify-content-center rounded-circle text-white">__LdB__</div>
                                    <div className="font-weight-bold mr-3">
                                        <div className="text-truncate">REPORTING ACCESS</div>
                                        <div className="small">Hi Team! Please check whether you have access to all the reports you require or I need to give you permissions.</div>
                                    </div>
                                    <span className="ml-auto mb-auto">
                                    <i className="text-success fa fa-check-circle"></i>
                                        {/* <div className="btn-group">
                                            <button type="button" className="btn btn-light btn-sm rounded" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="mdi mdi-dots-vertical"></i>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-delete"></i> Delete</button>
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-close"></i> Turn Off</button>
                                            </div>
                                        </div> */}
                                        <br />
                                        <div className="text-right text-muted pt-1">3d</div>
                                    </span>
                                </div>
                                </OverlayTrigger>
                                <OverlayTrigger trigger="click" placement="right" overlay={this.popover}>
                                <div className="p-3 d-flex align-items-center border-bottom osahan-post-header fuseHover">
                                    <div className="dropdown-list-image mr-3 d-flex align-items-center bg-secondary justify-content-center rounded-circle text-white">B.APP</div>
                                    <div className="font-weight-bold mr-3">
                                        <div className="text-truncate">HIGH-VALUE APPROVAL</div>
                                        <div className="small">You have a new high-value approval request to action and prioritize.</div>
                                    </div>
                                    <span className="ml-auto mb-auto">
                                    <i className="text-success fa fa-check-circle"></i>
                                        {/* <div className="btn-group">
                                            <button type="button" className="btn btn-light btn-sm rounded" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="mdi mdi-dots-vertical"></i>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-delete"></i> Delete</button>
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-close"></i> Turn Off</button>
                                            </div>
                                        </div> */}
                                        <br />
                                        <div className="text-right text-muted pt-1">3d</div>
                                    </span>
                                </div>
                                </OverlayTrigger>
                                <OverlayTrigger trigger="click" placement="right" overlay={this.popover}>
                                <div className="p-3 d-flex align-items-center border-bottom osahan-post-header fuseHover">
                                    <div className="dropdown-list-image mr-3 d-flex align-items-center bg-secondary justify-content-center rounded-circle text-white">B.APP</div>
                                    <div className="font-weight-bold mr-3">
                                        <div className="text-truncate">OVERDUE INVOICE APPROVALS</div>
                                        <div className="small">There are <strong>4 invoices</strong> that have been pending approval for longer than 2 days!</div>
                                    </div>
                                    <span className="ml-auto mb-auto">
                                    <i className="text-success fa fa-check-circle"></i>
                                        {/* <div className="btn-group">
                                            <button type="button" className="btn btn-light btn-sm rounded" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="mdi mdi-dots-vertical"></i>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-delete"></i> Delete</button>
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-close"></i> Turn Off</button>
                                            </div>
                                        </div> */}
                                        <br />
                                        <div className="text-right text-muted pt-1">4d</div>
                                    </span>
                                </div>
                                </OverlayTrigger>
                                <OverlayTrigger trigger="click" placement="right" overlay={this.popover}>
                                <div className="p-3 d-flex align-items-center border-bottom osahan-post-header fuseHover">
                                    <div className="dropdown-list-image mr-3 d-flex align-items-center bg-secondary justify-content-center rounded-circle text-white">B.APP</div>
                                    <div className="font-weight-bold mr-3">
                                        <div className="text-truncate">UNREAD NOTIFICATIONS</div>
                                        <div className="small">You have <strong>3 notifications</strong> that you haven't marked as read. Please action those messages.</div>
                                    </div>
                                    <span className="ml-auto mb-auto">
                                    <i className="text-success fa fa-check-circle"></i>
                                        {/* <div className="btn-group">
                                            <button type="button" className="btn btn-light btn-sm rounded" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="mdi mdi-dots-vertical"></i>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-delete"></i> Delete</button>
                                                <button className="dropdown-item" type="button"><i className="mdi mdi-close"></i> Turn Off</button>
                                            </div>
                                        </div> */}
                                        <br />
                                        <div className="text-right text-muted pt-1">5d</div>
                                    </span>
                                </div>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>      
          );
      }
  
  }
  
  const mapStateToProps = (state) => {
      return{
          fetchingData: state.fetchingData === true
      };
  }
  
  export default connect(
      // map state to props
      mapStateToProps, 
      // map dispatch to props
      (dispatch, ownProps) => ({
  
        })
      )(MessageBox);